import { TableRowData } from '../types/common.types';

export const anyRowSelected = (data: TableRowData[]) => {
  for (let i = 0; i < data.length; i++) {
    const object = data[i];
    if (object?.selected) return true;
  }

  return false;
};

export const allRowsSelected = (data: TableRowData[]) => {
  for (let i = 0; i < data.length; i++) {
    const object = data[i];
    if (!object?.selected) return false;
  }

  return true;
};

/**
 * Determines if an object is a placeholder object for the table.
 */
export const isPlaceholderObject = (object: TableRowData) => {
  if (!object) return true;

  const keys = Object.keys(object);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (key && object[key] !== '') return false;
  }

  return true;
};
